import React from "react";
import RichText from "components/rich-text";
import Image from "components/image";
import Link from "helpers/link";
import getModulePadding from "helpers/get-module-padding";

const VideoText = ({ data: { content, uspsData, videoUrl } }) => (
    <div className="container">
        <div className={`flex justify-between lg:flex-row flex-col ${getModulePadding()}`}>
            <div className="flex flex-col lg:w-1/2 w-full lg:mb-0 mb-8 pr-2">
                <div className="lg:max-w-md text-red text-gray-600 mb-4">
                    <RichText value={content?.data} data={content?.data} />
                </div>
                <div className="flex md:flex-row flex-col xl:gap-10 flex-wrap">
                    {uspsData?.length > 0 && (
                        uspsData.map((usps) => (
                            <div key={usps?.title} className="flex">
                                <div className="flex">
                                    <div className="md:flex hidden w-16">
                                        <Image image={usps?.icon?.asset} />
                                    </div>
                                    <div className="md:hidden flex w-12">
                                        <Image image={usps?.icon?.asset} />
                                    </div>
                                </div>
                                <div className="flex flex-col lg:text-lg text-base-xs justify-center">
                                    <p
                                        style={{ color: usps?.titleColor?.hex }}
                                        className="font-semibold"
                                    > 
                                        {usps?.title}
                                    </p>
                                    <Link
                                        style={{ color: usps?.subtitleColor?.hex }}
                                        className="font-normal -mt-2" 
                                        to={usps?.subtitle?.url}
                                    > 
                                        {usps?.subtitle?.title}
                                    </Link>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
            {videoUrl && (
                <div className="flex lg:w-1/2 w-full h-80">
                    <iframe title="Video" className="w-full" src={videoUrl} />
                </div>
            )}
        </div>
    </div>
);

export default VideoText;
